// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"1ac5979f","197":"e8175203","320":"55f48df8","505":"009cf85f","810":"ce89f6d4"}[chunkId] + ".chunk.js";
};